module.exports = __webpack_public_path__ + "img/jmb-logo-avatar.b3d7d9aa.png";